import React, {useEffect} from 'react';
import { Col, Row } from 'react-bootstrap';
import { GoogleLogout } from 'react-google-login';
import Loader from "../Shared/Loader";
import UsersTable from "../Shared/UsersTable/UsersTable";
import { GOOGLE_CLIENT_ID } from '../../config/constants';
import { logout } from '../../helpers';
import { startApiKeyOAuth } from '../../helpers/apiKeyOAuth';
import {
  useRolesDispatch,
  useUserDispatch,
  useUsersDispatch,
  useUsersState,
  useUserState,
} from "../../store/hooks";
import { useRouter } from '../../helpers/customHooks';

import '../Schedule/Badge/styles.scss';

export default () => {

  const { history } = useRouter();
  const user = useUserState();
  const { logoutUser } = useUserDispatch();

  const users = useUsersState();
  const { getUsers } = useUsersDispatch();
  const { getRoles } = useRolesDispatch();

  useEffect(() => {
    getUsers();
    getRoles();
  }, []);


  const failure = (response?: any) => {
    console.error('Google Logout failed:', response);
  };

  return (
    <>
      <Row>
        <Col lg={12} xs={12} style={{ height: 'calc(100vh - 110px)' }}>
          <div className="head-account">
            <h5>Your Practice Pro Account Information</h5>
          </div>
          <div className="account-02">
            <Row>
              <div className="a-d">
                <p><b>FULL NAME</b></p>
                <label>{user.name}</label>
              </div>
              <div className="a-d">
                <p><b>EMAIL ADDRESS</b></p>
                <label>{user.email}</label>
              </div>
              <div className="a-d">
                <p><b>YOUR TEAM</b></p>
                <label><img src={`../assets/images/logos/${user.teamShort}.svg`} alt="" width="25px" /> {user.teamName}
                </label>
              </div>
              <div className="a-d">
                <p><b>ACCOUNT TYPE</b></p>
                <label>{user.sbRole}</label>
              </div>
              <div className={"actions"}>
                <button className="btn-border btn-api-key" onClick={() => startApiKeyOAuth(user.email)}>
                  <i className="mdi mdi-key-variant"></i>
                  API Key
                </button>
                <div
                  id="google-logout"
                  className="loguot-l"
                  onClick={() => logout(history, logoutUser())}
                >
                  <GoogleLogout
                    clientId={GOOGLE_CLIENT_ID || ''}
                    buttonText="Sign Out"
                    onLogoutSuccess={() => logout(history, logoutUser())}
                    onFailure={failure}
                  >
                  </GoogleLogout>
                </div>
              </div>
            </Row>
          </div>
          <Loader>
          <div className={"account-info-users"}>
            <UsersTable users={users[user.teamId] ?? []} teamId={user.teamId} />
          </div>
        </Loader>
        </Col>
      </Row>
    </>
  );
};
